import { turnFlagOff, turnFlagOn } from '../../../api/featureManager';
import { queryClient, useMutation } from '../../../ReactQuery';
import type { FlagName } from '../../../../shared/featureFlags/types';

import { getGetAllFeatureFlagsQueryKey } from './useGetAllFeatureFlags';

type ToggleFlagParams = {
  flag: FlagName;
  enable: boolean;
};

async function toggleFeatureFlag({ flag, enable }: ToggleFlagParams): Promise<void> {
  if (enable) {
    await turnFlagOn(flag);
  } else {
    await turnFlagOff(flag);
  }
}

/**
 * Hook to toggle a feature flag on or off for the current organization.
 * @returns Mutation function to toggle feature flags
 */
export const useToggleFeatureFlag = () => {
  return useMutation({
    mutationFn: toggleFeatureFlag,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getGetAllFeatureFlagsQueryKey() });
    },
  });
};
